export type DeviceRegistrationRequestType ={
    RegisterationKey:string,
    AppType:string,
    DeviceCurrentTime:number,
}

export type HeaderRequestFormatType ={
    headers : {
        Authorization:string,
        "Ocp-Apim-Subscription-Key":string,
    }
}

export type InstallationRequestType = {
    AppType:string,  
}

export type MothershipRequestType={
    AppType:string,
    DeviceGuid:string
}

export type ConfigListRequestType={
    AppType:string,
}

export type ConfigDetailsRequestType={
    ConfigurationId:number|null
}


export const keyboardUrl="../AppInstaller/auxkeyboard/index.html";
